import { Record } from 'immutable';

const GrammaProRecord = Record({
  studentId: undefined,
  activationStartDate: undefined,
  activationEndDate: undefined,
  reportGeneratedDate: undefined,
  reportUrl: undefined,
  reports: undefined,
});

class GrammaPro extends GrammaProRecord { }

export default GrammaPro;



// WEBPACK FOOTER //
// ./data/GrammaPro/model/model.js